<template>
<transition name="modal">
    <div tabindex="0" @keydown="keyboardPress" ref="keyPadContainer"  v-bind:class="[classContainer]" class="pinCont">
    <div class="pin">
        <div class="dots">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
        </div>
        <p>Ingresa tu código</p>
        <div class="numbers">
            <div   @click="clickNumber" class="number">1</div>
            <div   @click="clickNumber" class="number">2</div>
            <div   @click="clickNumber" class="number">3</div>
            <div   @click="clickNumber" class="number">4</div>
            <div   @click="clickNumber" class="number">5</div>
            <div   @click="clickNumber" class="number">6</div>
            <div   @click="clickNumber" class="number">7</div>
            <div   @click="clickNumber" class="number">8</div>
            <div   @click="clickNumber" class="number">9</div>
            <div   @click="clickNumber" class="number">0</div>
        </div>
        <a  href="javascript:void(0)" v-if="mode == 'setCode'" @click="close">Cancelar</a>
        <a  href="javascript:void(0)" v-if="mode == 'requestCode'" @click="closeSesion">Cerrar Sesión</a>
    </div>
    </div>
</transition>
     
</template>

<style scoped>
.pinCont{
  background: #2185d0;
  align-items: center;
  justify-content: center;
  display: flex;
  /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto;
}
body {
  height: 100vh;
  background: #375ffa;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  font-family: Open Sans;
}
.wrong {
  -webkit-animation: bg-red 1s ease-in;
          animation: bg-red 1s ease-in;
}
.correct {
  -webkit-animation: bg-green 1s ease-in;
          animation: bg-green 1s ease-in;
}

#inspiration {
  position: fixed;
  right: 1em;
  bottom: 1em;
}
#inspiration a {
  display: inline-block;
  float: left;
  text-decoration: none;
  font-weight: bold;
  color: white;
  -webkit-transition: all 1s ease;
  transition: all 1s ease;
}
#inspiration a:hover {
  color: #212121;
}
#inspiration p {
  margin: 0;
  padding-left: .4em;
  display: inline-block;
  float: right;
  color: rgba(255, 255, 255, 0.6);
}

.pin {
  background: #212121;
  width: 20em;
  min-width: 320px;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
          justify-content: center;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
          flex-direction: column;
  padding: 1em;
  border-radius: .3em;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.3);
  margin: auto;
  color: rgba(255, 255, 255, 0.2);
}

.dots {
  width: 50%;
  display: -webkit-box;
  display: flex;
  justify-content: space-around;
  padding: 1em;
  padding-top: 3em;
}

.dot {
  position: relative;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.8em;
  width: 0.8em;
  height: 0.8em;
  -webkit-transform: scale3d(0.7, 0.7, 0.7);
          transform: scale3d(0.7, 0.7, 0.7);
}
.dot.active {
  -webkit-animation: growDot .5s ease;
          animation: growDot .5s ease;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}
.dot.wrong {
  -webkit-animation: wrong .9s ease;
          animation: wrong .9s ease;
}
.dot.correct {
  -webkit-animation: correct .9s ease;
          animation: correct .9s ease;
}

#pin p {
  font-size: .8em;
}

.numbers {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-flow: row wrap;
  -webkit-box-align: center;
          align-items: center;
  justify-content: space-around;
  align-content: flex-end;
  margin: 2em 0;
}

.number {
  padding: 0 !important;
  position: relative;
  width: 2.5em;
  height: 2.5em;
  margin: 0.5em;
  border-radius: 2.5em;
  border: 2px solid rgba(255, 255, 255, 0);
  text-align: center;
  line-height: 2.5em;
  font-weight: 400;
  font-size: 1.8em;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  -webkit-transition: all .5s ease;
  transition: all .5s ease;
}
.number:hover {
  color: rgba(255, 255, 255, 0.5);
}
.number:hover:before {
  border: 2px solid rgba(255, 255, 255, 0.5);
}
.number:before {
  content: "";
  position: absolute;
  left: -2px;
  width: 2.5em;
  height: 2.5em;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 2.5em;
  -webkit-transition: all .5s ease;
  transition: all .5s ease;
}
.number.grow:before {
  -webkit-animation: grow .6s ease;
          animation: grow .6s ease;
}

@-webkit-keyframes growDot {
  100% {
    background: white;
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
            transform: scale3d(0.9, 0.9, 0.9);
  }
}

@keyframes growDot {
  100% {
    background: white;
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
            transform: scale3d(0.9, 0.9, 0.9);
  }
}
@-webkit-keyframes grow {
  50% {
    -webkit-transform: scale3d(1.5, 1.5, 1.5);
            transform: scale3d(1.5, 1.5, 1.5);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}
@keyframes grow {
  50% {
    -webkit-transform: scale3d(1.5, 1.5, 1.5);
            transform: scale3d(1.5, 1.5, 1.5);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}
@-webkit-keyframes wrong {
  20% {
    background: crimson;
  }
  40% {
    -webkit-transform: translate(-15px, 0);
            transform: translate(-15px, 0);
  }
  60% {
    -webkit-transform: translate(10px, 0);
            transform: translate(10px, 0);
  }
  80% {
    -webkit-transform: translate(-5px, 0);
            transform: translate(-5px, 0);
  }
}
@keyframes wrong {
  20% {
    background: crimson;
  }
  40% {
    -webkit-transform: translate(-15px, 0);
            transform: translate(-15px, 0);
  }
  60% {
    -webkit-transform: translate(10px, 0);
            transform: translate(10px, 0);
  }
  80% {
    -webkit-transform: translate(-5px, 0);
            transform: translate(-5px, 0);
  }
}
@-webkit-keyframes correct {
  20% {
    background: limegreen;
  }
  40% {
    -webkit-transform: translate(0, -15px);
            transform: translate(0, -15px);
  }
  60% {
    -webkit-transform: translate(0, 10px);
            transform: translate(0, 10px);
  }
  80% {
    -webkit-transform: translate(0, -5px);
            transform: translate(0, -5px);
  }
}
@keyframes correct {
  20% {
    background: limegreen;
  }
  40% {
    -webkit-transform: translate(0, -15px);
            transform: translate(0, -15px);
  }
  60% {
    -webkit-transform: translate(0, 10px);
            transform: translate(0, 10px);
  }
  80% {
    -webkit-transform: translate(0, -5px);
            transform: translate(0, -5px);
  }
}
@-webkit-keyframes bg-red {
  50% {
    background: crimson;
  }
}
@keyframes bg-red {
  50% {
    background: crimson;
  }
}
@-webkit-keyframes bg-green {
  50% {
    background: limegreen;
  }
}
@keyframes bg-green {
  50% {
    background: limegreen;
  }
}

</style>

<script>
import {FirebaseSingleton} from '../../helpers/firebaseSingleton.js'
//const gAuth = auth();

export default {
  name: 'pinCodePad',
   components: {
       
   },
   props: ['value','mode'],
  data(){
    return{
      model:false,
      input:'',
      correct:'1234',
      dots:'',
      numbers:'',
      numbersBox:'',
      classContainer:''
    }
  },
  computed:{
   
  },
  watch:{
      value: function (newValue) {
            this.model = newValue
      }
  },
  methods:{
    close(){
        this.$emit('closePad')
    },
    closeSesion(){
        this.$swal({
            title: '¿Cerrar sesión de cajero?',
            text: "",
            icon: 'warning',
             allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Cerrar sesión de cajero',
            showLoaderOnConfirm: true,
            }).then(async (result) => {
                if (result.value) {
                      const fSingleton =  await FirebaseSingleton.init();
                      await fSingleton.auth.signOut();
                      location.reload();

                }
            });
    },
    toggle() {
        this.model = !this.value
        this.$emit("input", !this.value);
    },
    sendResult(){
        let response = {
            codeInput: this.input,
            codeCorrect:this.correct,
            success:(this.input == this.correct)?true:false,
        }
        this.$emit('onResponse',response);
    },
    clickNumber(evt){
           var number = evt.target;
            number.classList.add('grow');
            this.keyPadLogic(number.textContent);
           
            setTimeout( () => {
            number.className = 'number';
            }, 1000);
    },
    keyboardPress(key){
        if(isFinite(key.key)){
            this.keyPadLogic(key.key);
        }
    },
    keyPadLogic(input_value){
        this.input += input_value;
        this.dots[this.input.length - 1].classList.add("active");
        if (this.input.length >= 4) {
                if(this.mode == 'setCode'){
                    this.dots.forEach(dot => dot.classList.add('correct'));
                    this.classContainer = 'correct'
                    //this.sendResult();
                    //return false;
                }
                if(this.mode == 'requestCode'){
                    if (parseInt(this.input) !== parseInt(localStorage.getItem('validateCode'))) {
                    this.dots.forEach(dot => dot.classList.add('wrong'));
                    this.classContainer = 'wrong'
                    //$(document.body).addClass('wrong');

                    } else
                    {
                        this.dots.forEach(dot => dot.classList.add('correct'));
                        this.classContainer = 'correct'
                        //$(document.body).addClass('correct');
                    }
                }
                
                setTimeout( () => {
                    this.dots.forEach(dot => dot.className = 'dot');
                    this.sendResult();
                    this.input = '';
                }, 900);
                setTimeout( () => {
                    this.classContainer = ''
                    
                }, 1000);
            }
    }
  },
  beforeMount: function() {
    
  },
  destroyed() {
  
  },
  mounted:function(){
        this.$refs.keyPadContainer.focus();
        let dots = document.getElementsByClassName('dot');
        let numbers = document.getElementsByClassName('number');
        this.dots = Array.from(dots);
        this.numbers = Array.from(numbers);
        this.numbersBox = document.getElementsByClassName('numbers')[0];
         if(this.mode == 'requestCode'){
             this.correct = localStorage.getItem('validateCode');
         }
        /*document.addEventListener('keypress', (e) => {
            e = e || window.event;
            this.keyboardPress(e);
        });*/
        /*window.onkeypress =  (e) => {
            e = e || window.event;
            this.keyboardPress(e);
        };*/

      
    }
}
</script>